<template>
	<div id="groups">
		<h1><i class="fad fa-object-group fa-fw"></i> Groups (Tier 1)</h1>
		<div v-if="isLoading"><i class="fad fa-spinner-third fa-spin fa-2x"></i></div>
		<div v-else id="group-container" class="rec-container">
			<div class="rec" v-for="group in groupList" v-bind:key="group.id">
				<div>
					<h2>Group - {{groupId(group.id)}}</h2>
					<dl v-if="group.captain">
						<dt>Captains</dt>
						<dd v-for="captain in alphaSort(group.captain)" v-bind:key="captain.id">
							&ndash; <router-link v-bind:to="'/admin/user/edit/' + getUserID(captain,'id')">{{getUser(captain,'name')}}</router-link>
						</dd>
					</dl>
					<dl v-if="group.adjudicator">
						<dt>Adjudicators</dt>
						<dd v-for="adjudicator in alphaSort(group.adjudicator)" v-bind:key="adjudicator.id">
							&ndash; <router-link v-bind:to="'/admin/user/edit/' + getUserID(adjudicator,'id')">{{getUser(adjudicator,'name')}}</router-link>
						</dd>
					</dl>
					<dl v-if="group.applicant">
						<dt>Applicants</dt>
						<dd v-for="applicant in alphaSort(group.applicant)" v-bind:key="applicant.id">
							&ndash; <router-link v-bind:to="'/admin/user/edit/' + getUserID(applicant,'id')">{{getUser(applicant,'name')}}</router-link>
						</dd>
					</dl>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			isLoading: false
		};
		
	},
	computed: {
		groupList(){
			return this.$store.getters.groupsAll
		}
	},
	methods: {
		groupId(id){
			var parse_id = id.split('-')
			return parse_id[2]
		},
		getUserID(id){
			var rec = this.$store.getters.userUID(id)
			return rec.id
		},
		getUser(id){
			var rec = this.$store.getters.userUID(id)
			return `${rec.nameFirst} ${rec.nameLast}`
		},
		alphaSort(group){

			var group_list = group,
				group_obj = {}

			group_list.forEach(user => {
				group_obj[this.getUser(user)] = user
			});

			var sortedObj = Object.keys(group_obj)
			.sort()
			.reduce((acc, key) => ({
				...acc, [key]: group_obj[key]
			}), {})

			return sortedObj

		},
		async loadGroups() {
			this.isLoading = true
			await this.$store.dispatch('loadUsers')
			await this.$store.dispatch('loadGroups')
			setTimeout(()=>{ 
				this.isLoading = false
			},150)
		}
	},
	async created() {
		if( this.groupList.length < 1){
			await this.loadGroups()
		}
	}
}

</script>
<style scoped>
:root {
	--ar-purple: #483751;
}

.rec {
	align-items: flex-start;
	position: relative;
}

	.group {
		background-color: var(--ar-purple);
		color: #fff;
		display: block;
		padding: 3px;
		position: absolute;
		text-align: center;
		text-transform: uppercase;
		right: 0;
		top: 0;
	}

	.rec {
		align-items: flex-start;
	}

		.rec > div {
			width: 100%;
		}

		.rec h2 {
			border-bottom: 2px solid  var(--ar-purple);
			font-size: 2.1rem;
			margin-bottom: 1.2rem;
			padding-bottom: .3rem;
			width: 100%;
		}

		.rec dl {
			margin: 0.3rem 0 1.5rem 0.3rem;
		}

			.rec dt {
				border-bottom: 1px solid  var(--ar-purple);
				font-size: 1.8rem;
				font-weight: bold;
				margin-bottom: .9rem;
			}

			.rec dd {
				line-height: 1.5;
				margin-left: 0.3rem;
				padding: 3px 0;
			}
</style>